import React from "react";

const CTASection = () => {
  return (
    <>
      <style>{`
        @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");

        /* ================= SECTION ================= */
        .cta-section {
          position: relative;
          width: 100%;
          min-height: 280px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 60px 40px;
          font-family: "Poppins", sans-serif;
          overflow: hidden;
          background: linear-gradient(160deg, #0d1525 0%, #111827 50%, #0f172a 100%);
        }

        /* Floating ambient glow — subtle, pushed to edges */
        .cta-glow-left {
          position: absolute;
          left: -80px;
          top: 50%;
          transform: translateY(-50%);
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(99,102,241,0.18) 0%, transparent 70%);
          filter: blur(80px);
          pointer-events: none;
          z-index: 0;
        }

        .cta-glow-right {
          position: absolute;
          right: -80px;
          top: 50%;
          transform: translateY(-50%);
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(236,72,153,0.12) 0%, transparent 70%);
          filter: blur(80px);
          pointer-events: none;
          z-index: 0;
        }

        /* ================= CONTAINER ================= */
        .cta-container {
          position: relative;
          width: 100%;
          max-width: 1100px;
          text-align: center;
          padding: 58px 70px 52px;
          border-radius: 22px;
          background: rgba(255, 255, 255, 0.04);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          z-index: 2;
          /* Animated gradient border via outline trick */
          border: 2px solid transparent;
          background-clip: padding-box;
        }

        /* Animated gradient border — the pink/purple running border */
        .cta-container::before {
          content: "";
          position: absolute;
          inset: -2px;
          border-radius: 24px;
          padding: 2px;
          background: linear-gradient(
            270deg,
            #6366f1,
            #a855f7,
            #ec4899,
            #a855f7,
            #6366f1
          );
          background-size: 300% 300%;
          animation: borderMove 5s linear infinite;
          -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          z-index: -1;
        }

        @keyframes borderMove {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        /* ================= TITLE ================= */
        .cta-title {
          font-size: 40px;
          font-weight: 700;
          color: #ffffff;
          margin: 0 0 22px 0;
          line-height: 1.35;
          letter-spacing: -0.3px;
        }

        .cta-title span {
          background: linear-gradient(135deg, #818cf8 0%, #a78bfa 40%, #ec4899 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        /* ================= BODY TEXT ================= */
        .cta-text {
          font-size: 15.5px;
          font-weight: 400;
          line-height: 1.85;
          color: rgba(255, 255, 255, 0.72);
          max-width: 820px;
          margin: 0 auto 38px;
        }

        /* ================= BUTTON ================= */
        .cta-button-wrap {
          display: inline-block;
        }

        .cta-button {
          position: relative;
          display: inline-block;
          padding: 14px 52px;
          font-size: 15px;
          font-weight: 600;
          font-family: "Poppins", sans-serif;
          border-radius: 50px;
          border: none;
          cursor: pointer;
          color: #fff;
          background: linear-gradient(135deg, #7c3aed 0%, #9333ea 40%, #db2777 100%);
          overflow: hidden;
          transition: transform 0.35s ease, box-shadow 0.35s ease;
          box-shadow: 0 8px 32px rgba(168, 85, 247, 0.5);
          letter-spacing: 0.3px;
        }

        .cta-button:hover {
          transform: translateY(-4px) scale(1.04);
          box-shadow: 0 18px 50px rgba(168, 85, 247, 0.65);
        }

        .cta-button:active {
          transform: translateY(-1px) scale(1.01);
        }

        /* Shine sweep on hover */
        .cta-button .btn-shine {
          position: absolute;
          top: 0;
          left: -120%;
          width: 80%;
          height: 100%;
          background: linear-gradient(
            120deg,
            transparent 20%,
            rgba(255, 255, 255, 0.45) 50%,
            transparent 80%
          );
          transition: left 0.55s ease;
        }

        .cta-button:hover .btn-shine {
          left: 140%;
        }

        /* ================= RESPONSIVE ================= */
        @media (max-width: 1024px) {
          .cta-container {
            padding: 50px 50px 46px;
          }
          .cta-title {
            font-size: 34px;
          }
        }

        @media (max-width: 768px) {
          .cta-section {
            padding: 50px 20px;
          }
          .cta-container {
            padding: 42px 28px 38px;
            border-radius: 18px;
          }
          .cta-container::before {
            border-radius: 20px;
          }
          .cta-title {
            font-size: 26px;
            margin-bottom: 18px;
          }
          .cta-text {
            font-size: 14px;
            margin-bottom: 30px;
          }
          .cta-button {
            padding: 13px 40px;
            font-size: 14px;
          }
        }

        @media (max-width: 480px) {
          .cta-title {
            font-size: 22px;
          }
          .cta-container {
            padding: 36px 22px 32px;
          }
          .cta-text {
            font-size: 13.5px;
          }
        }
      `}</style>

      <section className="cta-section">
        <div className="cta-glow-left" />
        <div className="cta-glow-right" />

        <div className="cta-container">
          <h2 className="cta-title">
            Celebrate Your Special Moments in a{" "}
            <span>Luxury Private Theatre</span>
          </h2>

          <p className="cta-text">
            Make your celebrations unforgettable with The HexaPlay's private theatre
            experience. Perfect for birthdays, romantic proposals, anniversaries, movie nights,
            and gaming sessions, our premium theatre offers immersive screens, luxury décor,
            and complete privacy — creating a magical cinematic atmosphere for your most
            special moments.
          </p>

          <div className="cta-button-wrap">
            <a href="/" style={{ textDecoration: "none" }}>
              <button className="cta-button">
                Book Now
                <span className="btn-shine" />
              </button>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default CTASection;